import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs"
import { audit, map } from "rxjs/operators"

/**
 * This serialize all the operations doing and "audit" if the operations are send meanwhile previous operation
 * are executing
 */
 export interface OperationAuditSerializer<T,R> {

    state():Observable<boolean>

    serialize(entity:T,operation:((entity:T)=>Observable<R>)):void

    operationResults():Observable<R>

    finalize():void

}

export class DefaultSerializer<E,R> implements OperationAuditSerializer<E,R>{

    private busy:boolean = false
    private busySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false) //Notifies if an operation is in progress or not    
    private output: Subject<{entity:E,operation: (entity: E) => Observable<R>}> = new Subject() //Who receive the input serialized
    private reg: Subject<any> = new Subject() // Audit notifier to send the last input ( this is a semaphore)
    private result: Subject<R> = new Subject() // the operation result
    private outPutObservable: Observable<{entity:E,operation: (entity: E) => Observable<R>}> // Used to join the output with the audit operator. Holds the last message ... the clients subscrive to the Subject

    private subs:Subscription

    constructor(){
        this.outPutObservable = this.output.pipe(audit(ev => this.reg))      
        this.subs = this.outPutObservable.subscribe(p=>{
            this.busy = true
            this.busySubject.next(true)
            
            return p.operation(p.entity).pipe(map(o=>{                                
                this.result.next(o)
                this.busy = false
                this.busySubject.next(false)
                this.reg.next(true)
                
            })).subscribe(r=>{
                
            })

        })
    }

    operationResults():Observable<R>{
        return this.result
    }
    state(): Observable<boolean> {
        return this.busySubject
    }
    serialize(entity: E, operation: (entity: E) => Observable<R>): void {        
        this.output.next({entity:entity,operation:operation})
        if(this.busy == false){
            this.reg.next(true)
        }

    }

    finalize():void{
        this.subs.unsubscribe()
        this.busySubject.complete()
        this.reg.complete()
        this.output.complete()
        this.result.complete()        
    }

}